import React from "react";

const PromiseSkeleton = () => {
  return (
    <div className="animate-pulse w-full h-[320px]">
      <div className="bg-slate-200/80 rounded-2xl h-full">&ensp;</div>
    </div>
  );
};

export default PromiseSkeleton;
